export default __webpack_public_path__ + "static/media/CRS_7110-HDR-min.c518d4ee.jpg";